export default __webpack_public_path__ + "static/binaryPractice-2d9659004a4ef9024fbf3e7dd2910ccf.png";